module.exports = __webpack_public_path__ + "img/stock3.c5cbe11e.png";